<template>
  <component :is="currentComponent" :key="$route.params.modelId" />
</template>

<script>
import ImageGeneratorNew from './ImageGeneratorNew.vue'
import VideoGeneratorNew from './VideoGeneratorNew.vue'

export default {
  name: 'ModelGenerator',
  computed: {
    currentComponent: function () {
      var modelId = this.$route.params.modelId
      /* 已知的视频模型别名（不在 store videoModels 列表中的版本号 URL） */
      var videoAliases = ['seedance-1-5']
      if (videoAliases.indexOf(modelId) > -1) return VideoGeneratorNew
      var videoModels = this.$store.state.videoModels
      for (var i = 0; i < videoModels.length; i++) {
        if (videoModels[i].id === modelId) return VideoGeneratorNew
      }
      return ImageGeneratorNew
    }
  }
}
</script>
